// chemicalEngineeringData.js

const chemicalEngineeringData = [
    {
      section: "Engineering Fundamentals",
      subtotal: "10",
      courses: [
        {
          id: "EN1",
          code: "EN 1",
          title: "Applications in Eng.",
          credit: 3,
        },
        {
          id: "ES2_CS11",
          code: "ES 2 or CS 11",
          title: "Intro. Comp. in Eng. or Intro. Comp. Sci.",
          credit: 4,
        },
        {
          id: "ES10",
          code: "ES 10",
          title: "Intro. Materials Sci.",
          credit: 3,
        },
      ],
    },
    {
      section: "Mathematics",
      subtotal: "16",
      courses: [
        {
          id: "MATH32",
          code: "MATH 32",
          title: "Calculus I",
          credit: 4,
        },
        {
          id: "MATH34",
          code: "MATH 34",
          title: "Calculus II",
          credit: 4,
        },
        {
          id: "MATH42",
          code: "MATH 42",
          title: "Calculus III",
          credit: 4,
        },
        {
          id: "MATH51",
          code: "MATH 51",
          title: "Differential Equations",
          credit: 4,
        },
      ],
    },
    {
      section: "Natural Sciences",
      subtotal: "32",
      courses: [
        {
          id: "CHEM1_11",
          code: "CHEM 1/11",
          title: "Gen. Chem. I w/ lab or Exp. Gen. Chem. I w/ lab",
          credit: "5-6",
        },
        {
          id: "CHEM2_12",
          code: "CHEM 2/12",
          title: "Gen. Chem. II w/ lab or Exp. Gen. Chem. II w/ lab",
          credit: "5-6",
        },
        {
          id: "CHEM31",
          code: "CHEM 31",
          title: "Physical Chemistry I",
          credit: 4,
        },
        {
          id: "CHEM33",
          code: "CHEM 33",
          title: "Physical Chemistry Lab",
          credit: 2,
        },
        {
          id: "CHEM51",
          code: "CHEM 51",
          title: "Organic Chemistry I",
          credit: 4,
        },
        {
          id: "CHEM53",
          code: "CHEM 53",
          title: "Organic Chemistry I Lab",
          credit: 2,
        },
        {
          id: "PHY11",
          code: "PHY 11",
          title: "Gen. Physics I w/ lab",
          credit: 5,
        },
        {
          id: "BIO13",
          code: "BIO 13",
          title: "Cells & Organisms",
          credit: 3,
        },
        {
          id: "BIO15",
          code: "BIO 15",
          title: "Cells & Organisms lab",
          credit: 2,
        },
      ],
    },
    {
      section: "HASS",
      subtotal: "24",
      courses: [
        {
          id: "ENG1",
          code: "ENG 1",
          title: "Expos. Writing or ENG 3",
          credit: 3,
        },
        {
          id: "Humanities_Elec_a",
          code: "Humanities Elective (a)",
          title: "",
          credit: "≥3",
        },
        {
          id: "Social_Science_Elec_b",
          code: "Social Science Elective (b)",
          title: "",
          credit: "≥3",
        },
      ],
    },
    {
      section: "CHBE Core",
      subtotal: "33",
      courses: [
        {
          id: "CHBE10",
          code: "CHBE 10",
          title: "Chem. Proc. Prin.",
          credit: 3,
        },
        {
          id: "CHBE11",
          code: "CHBE 11",
          title: "Chem. Eng. Thermo.",
          credit: 3,
        },
        {
          id: "CHBE21",
          code: "CHBE 21",
          title: "Transport Phenom. I",
          credit: 3,
        },
        {
          id: "CHBE22",
          code: "CHBE 22",
          title: "Transport Phenom. II",
          credit: 3,
        },
        {
          id: "CHBE39",
          code: "CHBE 39",
          title: "Appl. Num. Methods",
          credit: 3,
        },
        {
          id: "CHBE45",
          code: "CHBE 45",
          title: "Chem. & Bio. Sep.",
          credit: 3,
        },
        {
          id: "CHBE51",
          code: "CHBE 51",
          title: "CHBE Lab",
          credit: 3,
        },
        {
          id: "CHBE52",
          code: "CHBE 52",
          title: "CHBE Lab",
          credit: 3,
        },
        {
          id: "CHBE60",
          code: "CHBE 60",
          title: "Prod. & Process Dsn.",
          credit: 3,
        },
        {
          id: "CHBE102",
          code: "CHBE 102",
          title: "Reactor Design",
          credit: 3,
        },
        {
          id: "CHBE109",
          code: "CHBE 109",
          title: "Proc. Dyn. & Control",
          credit: 3,
        },
      ],
    },
    {
      section: "Program Electives",
      subtotal: "15",
      courses: [
        {
          id: "Chem_Elec_d",
          code: "Chemistry Elective (d)",
          title: "",
          credit: "3-5",
        },
        {
          id: "Bio_Elec_e",
          code: "Biology Elective (e)",
          title: "",
          credit: "3-5",
        },
        {
          id: "Math_Sci_Elec_f",
          code: "Math & Science Elective (f)",
          title: "",
          credit: "3-5",
        },
        {
          id: "CHBE_Elec_g1",
          code: "CHBE Elective (g)",
          title: "",
          credit: 3,
        },
        {
          id: "CHBE_Elec_g2",
          code: "CHBE Elective (g)",
          title: "",
          credit: 3,
        },
      ],
    },
  ];
  
  export default chemicalEngineeringData;
  